import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ModalDialog } from "../components/ModalDialog";
import { lazyComponent } from "../components/lazy";
import { onOpenCopyTrader, onOpenRithmicDialog, type RithmicDialogMode } from "./topbarDialogs";

// Both load on first open (audit S-12): only these listeners are in the entry chunk.
const RithmicLoginDialogBody = lazyComponent(
  () => import("./RithmicLoginDialog").then((m) => m.RithmicLoginDialogBody),
  "Rithmic login",
);
const CopyTraderWindow = lazyComponent(
  () => import("../copy/CopyTraderWindow").then((m) => m.CopyTraderWindow),
  "copy trader",
);

/** "Add Rithmic account…" / "Log in to Rithmic…" from the status line's connection item. */
export function RithmicDialogHost(): React.JSX.Element | null {
  const [mode, setMode] = useState<RithmicDialogMode | null>(null);
  const close = useCallback(() => {
    setMode(null);
  }, []);
  useEffect(() => onOpenRithmicDialog(setMode), []);
  if (mode === null) return null;
  return (
    <ModalDialog
      title={mode === "add" ? "Add Rithmic account" : "Log in to Rithmic"}
      onClose={close}
      className="rithmic-dialog"
      returnFocus=".statusline-conn"
    >
      <RithmicLoginDialogBody key={mode} mode={mode} />
    </ModalDialog>
  );
}

/** The Copy trader pop-out from the top bar's Copy button; a second open keeps the one open. */
export function CopyTraderHost(): React.JSX.Element | null {
  const [open, setOpen] = useState(false);
  const [focusTick, setFocusTick] = useState(0);
  const close = useCallback(() => {
    setOpen(false);
  }, []);
  useEffect(
    () =>
      onOpenCopyTrader(() => {
        setOpen(true);
        setFocusTick((n) => n + 1);
      }),
    [],
  );
  useEffect(() => {
    if (focusTick > 0) document.querySelector<HTMLElement>(".copy-window")?.focus();
  }, [focusTick]);
  if (!open) return null;
  return createPortal(
    <div className="copy-window-layer">
      <CopyTraderWindow onClose={close} />
    </div>,
    document.body,
  );
}
